<template>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Please confirm</v-card-title>
        <v-card-text>{{text}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="onBtnClick(true)">{{proceedText}}</v-btn>
          <v-btn color="darken-1" @click="onBtnClick(false)">{{cancelText}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
	name: "ConfirmAction",
	props: {
		dialog: {
			type: Boolean,
			required: true
		},
		text: {
			type: String,
			required: true
		},
		proceedText: {
			type: String,
			required: true
		},
		cancelText: {
			type: String,
			required: true
		}
	},
	methods: {
		onBtnClick (proceed) {
			this.$emit(`onBtnClick`, proceed);
		}
	}
}
</script>